import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import tourPackagesService, { TOUR_PACKAGE_STATUS } from "services/admin/tour-packages.service";
import attributesService from "services/admin/attributesService";
import { snack } from "components/Snack/Snack";
import hotelsService from "services/admin/hotelsService";
import flightsService from "services/admin/flightsService";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Autocomplete, Button, Dialog, FormControl, InputLabel, MenuItem, Select, Table, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { toNativeDate } from "helpers/dateHelper";
import { toFormData } from "helpers/formUtils";
import _ from "lodash";
import { FlightsDialog } from "components/FlightsDialog";
import { useState } from "react";
import tourScheduleService from "services/admin/tourScheduleService";
import tourPackageCategoryAdminService from "services/admin/tourpackageCategoryService";
import { CurrencyInput } from "components/CurrencyInput/CurrencyInput";
import { TourPackageHotelForm } from "./TourPackageHotelForm";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { countriesService } from "services/countries.service";
import { citiesService } from "services/cities.service";

/**
 * TODO:
 * - Добавить валидация для начала и конца. Конца не может быть ранее чем начало
 * - Не отображать список всех рейсов в форме а сделать как выборку через dropdown
 * - Отели также
 * - Статус по умолчанию: Активный
 * - Изменить название кнопки на Сохранить/Изменить тур
 * - Валидация: Дата начало тура не может меньше сегодняшнего дня
 * - Валидация: Стоимость тура не может быть буквами, и меньше 100$
 * - Отели должны быть отдельной таблицей
 * - В детали тура возвращать список отелей
 * - В детали тура возвращать список рейсов туда и обратно
 * - Атрибуты связка с турам должны быть в отдельной таблице также
 * - Кнопка Save должно быть неактивный если не прошла валидацию
 */
const TourPackageForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: {
    tourPackage,
    attributes,
    hotels,
    flights,
    tourSchedules,
    tourPackageCategories,
    countries,
    cities,
  },
}) => {
  const { t } = useTranslation()
  flights.data = flights.data.filter(f => f.status === 'active')

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      photo: tourPackage ? tourPackage.photo : '',
      name: tourPackage ? tourPackage.name : '',
      description: tourPackage ? tourPackage.description : '',
      flightsTo: tourPackage ? tourPackage.flightsTo : [],
      returnFlights: tourPackage ? tourPackage.returnFlights : [],
      price: tourPackage ? tourPackage.price : '',
      currency: tourPackage ? tourPackage.currency : 'KZT',
      childPrice: tourPackage ? tourPackage.childPrice : '',
      infantPrice: tourPackage ? tourPackage.infantPrice : '',
      startDate: tourPackage ? tourPackage.startDate : toNativeDate(new Date()),
      endDate: tourPackage ? tourPackage.endDate : toNativeDate(new Date()),
      attributes: tourPackage ? tourPackage.attributes.map(a => a.id) : [],
      hotels: tourPackage ? tourPackage.hotels.map(h => {
        return {
          TourToHotel: {
            hotelID: h.TourToHotel.hotelID,
            startDate: h.TourToHotel.startDate,
            endDate: h.TourToHotel.endDate
          }
        }
      }) : [],
      status: tourPackage ? tourPackage.status : TOUR_PACKAGE_STATUS.DRAFT,
      tourScheduleID: tourPackage ? tourPackage.tourScheduleID : '',
      tourpackageCategoryID: tourPackage ? tourPackage.tourpackageCategoryID : '',
      prepaymentAmount: tourPackage ? tourPackage.prepaymentAmount : '',
      departureCountryID: tourPackage ? tourPackage.departureCountryID : '',
      departureCityID: tourPackage ? tourPackage.departureCityID : '',
      baseCountryID: tourPackage ? tourPackage.baseCountryID : '',
      baseCityID: tourPackage ? tourPackage.baseCityID : '',
    },
  });

  console.log(`form errors:`, methods.formState.errors);

  const startDate = methods.watch('startDate')
  const endDate = methods.watch('endDate')
  const flightsTo = methods.watch('flightsTo')
  const returnFlights = methods.watch('returnFlights')
  const [flightsToDialogVisible, setFlightsToDialogVisible] = useState(false)
  const [flightsReturnDialogVisible, setFlightsReturnDialogVisible] = useState(false)

  async function onSubmit() {
    if (!methods.formState.isValid) {
      snack('Пожалуйста, проверьте что данные правильно заполнены!')
      return
    }

    try {
      const formData = toFormData(methods.getValues())

      if (tourPackage) {
        await tourPackagesService.put(id, formData)
        toast.success("Турпакет обновлен успешно!");
        setTimeout(() => {
          navigate(`/admin/tour-packages/view/${tourPackage.id}`);
        }, 500);
      } else {
        const { data: createdTourPackage } = await tourPackagesService.post(formData)
        console.log("createdTourPackage:", createdTourPackage);

        toast.success("Турпакет создан успешно!");
        setTimeout(() => {
          navigate(`/admin/tour-packages/view/${createdTourPackage.id}`);
        }, 500);
      }
    } catch (ex) {
      console.error(ex)
      snack(ex?.message)
    }
  }

  function displayErrors(type) {
    const errors = methods.formState.errors
    // For all required type
    if (errors && errors[type] && errors[type].type === 'required') {
      return `Заполните поле`
    }
    return null
  }

  function onFlightSelected(flight, direction) {
    if (direction === 'to') {
      setFlightsToDialogVisible(false)
      methods.setValue('flightsTo', [...methods.getValues('flightsTo'), flight])
    }
    if (direction === 'return') {
      setFlightsReturnDialogVisible(false)
      methods.setValue('returnFlights', [...methods.getValues('returnFlights'), flight])
    }
  }

  function removeFlight(flightIndex, direction) {
    console.log(`removeFlight: `, { flightIndex, direction });

    if (direction === "to") {
      const _flightsTo = methods.getValues('flightsTo')
      methods.setValue('flightsTo', _flightsTo.filter((_, inx) => flightIndex !== inx))
    }

    if (direction === "return") {
      methods.setValue('returnFlights', methods.getValues('returnFlights').filter((_, inx) => flightIndex !== inx))
    }
  }

  return (
    <CrudPage title={tourPackage ? 'Редактирование турпакета' : 'Создание турпакета'}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="tour-form app-form">
          <div>
            <div className="preview">
              <label>Фото турпакета</label>
              {typeof methods.getValues('photo') === "string" ? (
                <div style={{ width: 100, height: 'auto', marginTop: "1rem" }}>
                  <img src={methods.getValues('photo')} alt="" />
                </div>
              ) : null}
            </div>
            <TextField
              {...methods.register('photo')}
              type="file"
              error={_.has(methods.formState.errors, 'photo')}
              helperText={displayErrors('photo')}
              placeholder="Фото турпакета"
              onChange={(e) => {
                const file = e.target.files[0]
                const max = 5 * 1000 * 1000; // 5MB                
                if (file && file.size > max) {
                  snack(
                    "Вы не можете загружать большие файлы! Пожалуйста используйте файл маленького размера"
                  );
                }
                const fileReader = new FileReader();
                const previewNode = document.querySelector('.tour-form .preview')
                if (!previewNode.querySelector('img')) {
                  const img = document.createElement('img')
                  const imgWrapper = document.createElement('div')
                  imgWrapper.style = 'width: 100px; height: auto; margin-top: 1rem;'
                  imgWrapper.appendChild(img)
                  previewNode.appendChild(imgWrapper)
                }
                const previewImage = previewNode.querySelector('img')

                fileReader.onload = event => {
                  previewImage.setAttribute('src', event.target.result);
                }
                fileReader.readAsDataURL(file);
              }}
            />
          </div>
          <div>
            <TextField
              fullWidth {...methods.register('name', { required: true })}
              type='text'
              label='Название турпакета *'
              error={_.has(methods.formState.errors, 'name')}
              helperText={displayErrors('name')}
            ></TextField>
          </div>
          <div>
            <TextField
              aria-invalid="true"
              fullWidth {...methods.register('description', { required: true })}
              type='text'
              label='Краткое описание *'
              multiline rows={3}
              error={_.has(methods.formState.errors, 'description')}
              helperText={displayErrors('description')}
            ></TextField>
          </div>

          <section>
            <h3 className="m-b-16">Страна и город вылета</h3>
            <div className="mb-4">
              <Controller
                control={methods.control}
                name="departureCountryID"
                rules={{ required: true }}
                render={({ field }) => {
                  return <FormControl fullWidth>
                    <InputLabel>Выберите страну вылета</InputLabel>
                    <Select value={field.value} onChange={(e) => {
                      field.onChange(e.target.value)
                      methods.setValue('departureCityID', null, { shouldValidate: true })
                    }} className="w-100" label="Выберите страну вылета">
                      {countries.data.map(c => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                }}
              ></Controller>
            </div>
            <div>
              <Controller
                control={methods.control}
                name="departureCityID"
                rules={{ required: true }}
                render={({ field }) => {
                  return <FormControl fullWidth>
                    <InputLabel>Выберите город вылета</InputLabel>
                    <Select value={field.value} onChange={field.onChange} className="w-100" label="Выберите город вылета">
                      {cities ?
                        cities.data.filter(c => c.countryID === methods.getValues('departureCountryID')).map(c => {
                          return <MenuItem key={c.id} value={c.id}>
                            {c.name}
                          </MenuItem>
                        })
                        : []}
                    </Select>
                  </FormControl>
                }}
              ></Controller>
            </div>
          </section>

          <section>
            <h3 className="m-b-16">Страна и город назначения</h3>
            <div className="mb-4">
              <Controller
                control={methods.control}
                name="baseCountryID"
                rules={{ required: true }}
                render={({ field }) => {
                  return <FormControl fullWidth>
                    <InputLabel>Выберите страну назначения</InputLabel>
                    <Select value={field.value} onChange={(e) => {
                      field.onChange(e.target.value)
                      methods.setValue('baseCityID', null, { shouldValidate: true })
                    }} className="w-100" label="Выберите страну назначения">
                      {countries.data.map(c => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                }}
              ></Controller>
            </div>
            <div>
              <Controller
                control={methods.control}
                name="baseCityID"
                rules={{ required: true }}
                render={({ field }) => {
                  return <FormControl fullWidth>
                    <InputLabel>Выберите город назначения</InputLabel>
                    <Select value={field.value} onChange={field.onChange} className="w-100" label="Выберите город назначения">
                      {cities ?
                        cities.data.filter(c => c.countryID === methods.getValues('baseCountryID')).map(c => {
                          return <MenuItem key={c.id} value={c.id}>
                            {c.name}
                          </MenuItem>
                        })
                        : []}
                    </Select>
                  </FormControl>
                }}
              ></Controller>
            </div>
          </section>

          <section id="prices" className="m-t-32">
            <h3 className="m-b-16">Стоимость тура</h3>
            <p className="fs-14">Задайте стоимость тура для взрослого, ребенка и младенца</p>
            <div className="m-b-16">
              <Controller
                control={methods.control}
                name="currency"
                rules={{ required: true }}
                render={({ field }) => {
                  return <CurrencyInput value={field.value} onChange={field.onChange} options={{ disabled: true }} />
                }}
              />
            </div>
            <div className="m-b-16">
              <TextField
                fullWidth {...methods.register('price', { required: true, min: 100 })}
                type='number'
                label='*Стоимость тура для взрослого'
                error={_.has(methods.formState.errors, 'price')}
                helperText={displayErrors('price')}
              ></TextField>
            </div>
            <div className="m-b-16">
              <TextField
                fullWidth {...methods.register('childPrice', { required: true, min: 100 })}
                type='number'
                label='*Стоимость тура для ребенка'
                error={_.has(methods.formState.errors, 'childPrice')}
                helperText={displayErrors('childPrice')}
              ></TextField>
            </div>
            <div className="m-b-16">
              <TextField
                fullWidth {...methods.register('infantPrice', { required: true, min: 100 })}
                type='number'
                label='*Стоимость тура для младенца'
                error={_.has(methods.formState.errors, 'infantPrice')}
                helperText={displayErrors('infantPrice')}
              ></TextField>
            </div>
          </section>
          <div>
            <TextField
              fullWidth {...methods.register('prepaymentAmount', { required: true, min: 500 })}
              type='number'
              label='Предоплата(в тенге)'
              error={_.has(methods.formState.errors, 'prepaymentAmount')}
              helperText={displayErrors('prepaymentAmount')}
            ></TextField>
          </div>
          <section className="m-t-32">
            <h3 className="m-b-16">Дата начала и конца тура</h3>
            <div className="flex gap-8">
              <div>
                <TextField
                  helperText={displayErrors('startDate')}
                  label="Дата начала тура"
                  error={_.has(methods.formState.errors, 'startDate')}
                  fullWidth
                  {...methods.register('startDate', { required: true })}
                  type='date'
                  inputProps={{ min: startDate }}
                ></TextField>
              </div>
              <div>
                <TextField
                  helperText={displayErrors('endDate')}
                  label="Дата конца тура"
                  error={_.has(methods.formState.errors, 'endDate')}
                  fullWidth {...methods.register('endDate', { required: true })}
                  type='date'
                  inputProps={{ min: methods.getValues('startDate') }}
                ></TextField>
              </div>
            </div>
          </section>

          <section id="flightsTo" className="m-t-32">
            <h3 className="m-b-16">Рейсы туда</h3>
            <div className="m-t-16">
              <Table>
                <TableHead>
                  <TableCell>ID Расписания</TableCell>
                  <TableCell>Номер рейса</TableCell>
                  <TableCell>Направление</TableCell>
                  <TableCell>Дата вылета</TableCell>
                  <TableCell>Дата прилета</TableCell>
                  <TableCell>Длительность</TableCell>
                  <TableCell></TableCell>
                </TableHead>
                {flightsTo?.map((f, flightIndex) => {
                  return <TableRow className="">
                    <TableCell>{_.get(f, 'id')}</TableCell>
                    <TableCell>{_.get(f, 'flightNumber')}</TableCell>
                    <TableCell>{f.departureAirport.airportCode}-{f.arrivalAirport.airportCode}</TableCell>
                    <TableCell>{_.get(f, 'TourToFlight.departureDate')}</TableCell>
                    <TableCell>{_.get(f, 'TourToFlight.arrivalDate')}</TableCell>
                    <TableCell>
                      {`${f.durationHours} ч ${f.durationMinutes} мин`}
                    </TableCell>
                    <TableCell>
                      <Button type="button" onClick={() => removeFlight(flightIndex, 'to')} variant="outlined">Удалить</Button>
                    </TableCell>
                  </TableRow>
                })}
              </Table>
            </div>
            <div className="m-t-16">
              <Button onClick={() => setFlightsToDialogVisible(true)}>Добавить рейс</Button>
            </div>
          </section>
          <div className="m-t-32">
            <h3 className="m-b-16">Рейсы обратно</h3>
            <Table>
              <TableHead>
                <TableCell>ID Расписания</TableCell>
                <TableCell>Номер рейса</TableCell>
                <TableCell>Направление</TableCell>
                <TableCell>Дата вылета</TableCell>
                <TableCell>Дата прилета</TableCell>
                <TableCell>Длительность</TableCell>
                <TableCell></TableCell>
              </TableHead>
              {returnFlights?.map((f, flightIndex) => {
                return <TableRow className="">
                  <TableCell>{_.get(f, 'id')}</TableCell>
                  <TableCell>{_.get(f, 'flightNumber')}</TableCell>
                  <TableCell>{f.departureAirport.airportCode}-{f.arrivalAirport.airportCode}</TableCell>
                  <TableCell>{_.get(f, 'TourToFlight.departureDate')}</TableCell>
                  <TableCell>{_.get(f, 'TourToFlight.arrivalDate')}</TableCell>
                  <TableCell>{`${f.durationHours} ч ${f.durationMinutes} мин`}</TableCell>
                  <TableCell>
                    <Button type="button" onClick={() => removeFlight(flightIndex, 'return')}>Удалить</Button>
                  </TableCell>
                </TableRow>
              })}
            </Table>
            <div className="m-t-16">
              <Button onClick={() => setFlightsReturnDialogVisible(true)}>Добавить рейс</Button>
            </div>
          </div>

          <section className="m-t-32">
            <TourPackageHotelForm hotels={hotels.data} tourPackageID={id} />
          </section>

          <section>
            <h3>Пожалуйста, выберите подходящие атрибуты из списка</h3>
            <div>
              <Controller
                control={methods.control}
                name="attributes"
                rules={{ required: true }}
                render={({ field }) => {
                  return <Autocomplete
                    value={field.value ? field.value.map(id => {
                      const f = attributes.data.find(m => m.id === id)
                      return {
                        id: f.id,
                        name: f.name
                      }
                    }) : []}
                    className="m-t-16"
                    multiple
                    options={attributes.data.map(f => ({ id: f.id, name: f.name }))}
                    getOptionLabel={(o) => o.name}
                    isOptionEqualToValue={(o, v) => {
                      return o.id === v.id
                    }}
                    renderInput={(params) => <TextField
                      helperText={displayErrors('attributes')}
                      error={_.has(methods.formState.errors, 'attributes')}
                      {...params}
                      label="Выберите атрибут" />}
                    onChange={(e, v) => {
                      field.onChange(v.map(x => x.id))
                    }}
                  ></Autocomplete>
                }}
              ></Controller>
            </div>
          </section>

          <section>
            <Controller
              control={methods.control}
              name="tourScheduleID"
              render={({ field }) => {
                return <FormControl fullWidth>
                  <InputLabel>Выберите расписание</InputLabel>
                  <Select
                    value={field.value}
                    onChange={field.onChange}
                    className="w-100"
                    label="Выберите расписание"
                  >
                    {tourSchedules.data.map(s => {
                      return <MenuItem value={s.id}>{s.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              }}
            ></Controller>
          </section>

          <section>
            <Controller
              control={methods.control}
              name="tourpackageCategoryID"
              render={({ field }) => {
                return <FormControl fullWidth>
                  <InputLabel>Выберите категорию</InputLabel>
                  <Select
                    value={field.value}
                    onChange={field.onChange}
                    className="w-100"
                    label="Выберите категорию"
                    disabled={!!id}
                  >
                    {tourPackageCategories.data.map(c => {
                      return <MenuItem value={c.id}>{c.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              }}
            ></Controller>
          </section>

          <div className="m-t-32">
            <h3 className="m-b-16">Статус</h3>
            <Controller
              control={methods.control}
              name="status"
              render={({ field }) => {
                return <FormControl fullWidth>
                  <InputLabel>Статус</InputLabel>
                  <Select
                    value={field.value}
                    onChange={field.onChange}
                    className="w-100"
                    label="Статус"
                  >
                    {Object.values(TOUR_PACKAGE_STATUS).map(s => {
                      return <MenuItem value={s} key={s}>{t(s)}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              }}
            ></Controller>
          </div>

          <Dialog fullWidth maxWidth="lg" open={flightsToDialogVisible} onClose={() => { setFlightsToDialogVisible(false) }}>
            <FlightsDialog onSelect={(f) => onFlightSelected(f, 'to')} startDate={startDate} schedules={flights.data}></FlightsDialog>
          </Dialog>

          <Dialog fullWidth maxWidth="lg" open={flightsReturnDialogVisible} onClose={() => { setFlightsReturnDialogVisible(false) }}>
            <FlightsDialog onSelect={(f) => onFlightSelected(f, 'return')} startDate={endDate} schedules={flights.data}></FlightsDialog>
          </Dialog>

          <div className="m-t-32 m-b-32">
            <Button type="submit" variant="contained" disabled={!methods.formState.isValid}>
              {tourPackage ? `Обновить турпакет` : `Создать турпакет`}
            </Button>
          </div>

          {/* <pre className="m-t-32">
            {JSON.stringify(methods.watch(), null, 4)}
          </pre> */}
        </form>
      </FormProvider>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(TourPackageForm, (router) => {
    let requests = {
      attributes: () => attributesService.getAll(),
      hotels: () => hotelsService.getAll(),
      flights: () => flightsService.getAll(),
      tourSchedules: () => tourScheduleService.getAll(),
      tourPackageCategories: () => tourPackageCategoryAdminService.getAll(),
      countries: () => countriesService.getAll(),
      cities: () => citiesService.getAll(),
    }
    if (router.params.id) {
      requests['tourPackage'] = () => tourPackagesService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
